module.exports = __webpack_public_path__ + "static/img/food_back.0604bb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/food_back.jpg?20181011
// module id = b+lP
// module chunks = 1